export default class ErrorIgnoreSentry extends Error {
  status?: number;

  constructor(status?: number, message?: string) {
    super(message);
    this.name = 'ErrorIgnoreSentry';
    this.status = status;
  }
}
